import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare const Office: any;

if (environment.production) {
    enableProdMode();
}

function initApp() {
    platformBrowserDynamic()
        .bootstrapModule(AppModule)
        .catch((err) => console.error(err));
}

function startOfficeScript() {
    Office.onReady(function () {
        initApp();

        Office.initialize = function () {};
    });
}

function initOfficeScript() {
    let officeScript = document.createElement('script');
    officeScript.type = 'text/javascript';
    officeScript.async = false;
    officeScript.src = 'https://appsforoffice.microsoft.com/lib/1/hosted/office.js';
    document.head.appendChild(officeScript);

    officeScript.addEventListener('load', () => {
        startOfficeScript();
    });
}

if (environment.localDevData) {
    initApp();
} else if (environment.extension === 'outlook') {
    initOfficeScript();
} else {
    initApp();
}
